import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./style.css";
import { useInView } from "react-intersection-observer";
const SpinningText = ({
  text = "",
  textSize = "text-5xl",
  marginTop = null,
  textCenter = null,
  color = null,
}) => {
  const { ref, inView } = useInView({ threshold: 0.3 });
  const [animateState, setAnimateState] = useState({ rotateX: "0deg" });
  useEffect(() => {
    if (inView) {
      setAnimateState({
        rotateX: "0deg",
      });
    } else {
      setAnimateState({
        rotateX: "270deg",
      });
    }
  }, [inView]);

  return (
    <>
      <div
        className={`${marginTop && "mt-48"}   overflow-hidden w-[fit-content] ${
          textCenter && "mx-auto"
        } relative sliding-text-container mb-4`}
      >
        <div ref={ref} className='flex justify-center'>
          {text.split("").map((letter, index) => {
            if (letter === " ") {
              return (
                <motion.p
                  initial={{ rotateX: "270deg" }}
                  animate={animateState}
                  transition={{
                    type: "tween",
                    duration: 0.5,
                    delay: 0.05 * index,
                  }}
                  className={`${textSize} font-medium ${color ? color : ""}`}
                >
                  &nbsp;
                </motion.p>
              );
            }
            return (
              <motion.p
                initial={{ rotateX: "270deg" }}
                animate={animateState}
                transition={{
                  type: "tween",
                  duration: 0.5,
                  delay: 0.05 * index,
                }}
                className={`${textSize} font-medium ${color ? color : ""}`}
              >
                {letter}
              </motion.p>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SpinningText;
